import { Component, OnInit, Input } from "@angular/core";
import { Order } from "src/app/shared/models/order.model";
import { OrderTrackerComponent } from "../order-tracker/order-tracker.component";
import { TranslateModule } from "@ngx-translate/core";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { CommonModule } from "@angular/common";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "activity-log",
  templateUrl: "./activity-log.component.html",
  styleUrls: ["./activity-log.component.scss"],
  imports: [
    TranslateModule,
    OrderTrackerComponent,
    TableComponent,
    CommonModule,
  ],
  standalone: true,
})
export class ActivityLogComponent implements OnInit {
  @Input() order: Order;

  get isNew(): boolean {
    return this.order.statusCode == "CLINIC_SIGNED";
  }

  get isLabUser(): boolean {
    return this.authService.currentUser.isLabUser;
  }

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}
}
